import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { ListCountriesResponse } from './countries.types'

const listCountries = async (): Promise<ListCountriesResponse> => {
  const response = await apiClient.get<ListCountriesResponse>(
    '/v1/platform/countries',
  )
  return response.data
}

export const useListCountries = () => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: () => listCountries(),
    staleTime: 1000 * 60 * 60, // 1 hour - countries don't change often
  })
}
